import { createContext, useContext, useState, useEffect } from 'react';
import { getCurrentCurrency } from '../lib/api';

const CurrencyContext = createContext({
  currency: 'USD',
  symbol: '$',
  locale: 'en-US',
  loading: true,
  refreshCurrency: () => {}
});

export function CurrencyProvider({ children }) {
  const [currency, setCurrency] = useState({
    code: 'USD',
    symbol: '$',
    locale: 'en-US',
    name: 'US Dollar'
  });
  const [loading, setLoading] = useState(true);

  const fetchCurrency = async () => {
    try {
      const response = await getCurrentCurrency();
      setCurrency(response.data);
    } catch (error) {
      console.error('Failed to fetch currency:', error);
      // Keep default USD
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCurrency();
  }, []);

  const refreshCurrency = () => {
    fetchCurrency();
  };

  // Format price helper function
  const formatPrice = (value) => {
    if (value === null || value === undefined) return '$0.00';
    try {
      return new Intl.NumberFormat(currency.locale || 'en-US', {
        style: 'currency',
        currency: currency.code || 'USD',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(value);
    } catch {
      return `$${Number(value).toFixed(2)}`;
    }
  };

  return (
    <CurrencyContext.Provider value={{
      currency: currency.code,
      symbol: currency.symbol,
      locale: currency.locale,
      name: currency.name,
      loading,
      refreshCurrency,
      formatPrice
    }}>
      {children}
    </CurrencyContext.Provider>
  );
}

export function useCurrency() {
  return useContext(CurrencyContext);
}

// Helper function to format currency
export function formatCurrencyValue(value, currencyData) {
  const { code = 'USD', locale = 'en-US' } = currencyData || {};
  
  try {
    return new Intl.NumberFormat(locale, {
      style: 'currency',
      currency: code,
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(value);
  } catch {
    // Fallback if currency not supported
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD'
    }).format(value);
  }
}
